import React from 'react';
import styled from 'styled-components';
import { ScreenSizes } from "../../types/responsive";

const BackToTopWrapper = styled.div`
  position: fixed;
  right: 10rem;
  bottom: 1rem;
  opacity: 0;
  z-index: 999;
  transition: all 0.4s ease;
  &.visible {
    opacity: 1;
  }
  @media (max-width: ${ScreenSizes.sm}) {
    right: 5rem;  
  }
`;

const BackToTopButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(-135deg, #aab5ea 0%, #41d7bd 100%);
  border: none;
  .arrow {
    margin: 0;
    transform: rotate(180deg);

    &::before,
    &::after {
      position: relative;
      content: '';
      display: block;
      height: 1.5px;
      background: #fff;
    }

    &::before {
      width: 12px;
      left: -4px;
      top: 1px;
      transform: rotate(45deg);
    }

    &::after {
      width: 14px;
      left: 4px;
      transform: rotate(-45deg);
    }
  }
`;

const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  const handleScroll = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <BackToTopWrapper className={`${isVisible ? 'visible' : ''}`}>
      <BackToTopButton
        aria-label="Back to top"
        onClick={() => {
          window.scrollTo({top: 0, behavior: 'smooth'});
        }}>
        <div className="arrow" />
      </BackToTopButton>
    </BackToTopWrapper>
  );
};

export default BackToTop;
